<template>
  <div class="page">
    <div class="box">
      <div class="bd">
        <div class="block_3">
          <div class="group_2">
            <span class="text_3" :lines="1">全部课程</span>
            <span class="txt_2" :lines="1">&gt;</span>
            <span class="word_4" :lines="1">IT</span>
            <span class="text_4" :lines="1">学院</span>
            <span class="javaPrev" :lines="1">&gt;</span>
            <span class="java" :lines="1">JAVA</span>
            <span class="javaNext" :lines="1">&gt;</span>
            <span class="info_3" :lines="1">微信小程序开发入门</span>
          </div>
          <img
            class="banner"
            src="./images/img_32419_0_21.png"
          />
        </div>
        <div class="group_5">
          <span class="summary" :lines="2"
            >微信小程序开发入门微信小程序开发入门微信小程序开发入门</span
          >
          <div class="container_3">
            <img
              class="dot"
              src="./images/img_32419_0_22.png"
            />
            <div class="empty" />
            <div class="group_3">
              <span class="word_5" :lines="1">教学模式</span>
              <span class="text_5" :lines="1">录播</span>
            </div>
            <div class="div" />
            <div class="container_2">
              <img
                class="dot_2"
                src="./images/img_32419_0_23.png"
              />
            </div>
            <div class="outer_2">
              <span class="info_4" :lines="1">课程有效期</span>
              <span class="word_6" :lines="1">无限期</span>
            </div>
            <div class="empty_2" />
            <div class="block_4">
              <div class="empty_3" />
              <div class="div_2" />
            </div>
            <div class="group_4">
              <span class="text_6" :lines="1">学习人数</span>
              <div class="wrap">
                <span class="num" :lines="1">68</span>
                <span class="txt_3" :lines="1">人</span>
              </div>
            </div>
          </div>
          <div class="priceWrap">
            <span class="rmb" :lines="1">¥</span>
            <span class="price" :lines="1">899.00</span>
          </div>
          <div class="tagWrap">
            <span class="tag" :lines="1">购买课程</span>
          </div>
        </div>
        <img
          class="icon_3"
          src="./images/img_32419_0_20.png"
        />
        <img
          class="icon_4"
          src="./images/img_32419_0_19.png"
        />
      </div>
      <div class="main">
        <div class="block_9">
          <div class="container_5">
            <div class="container_4">
              <span class="txt_4" :lines="1">课程介绍</span>
            </div>
            <div class="outer_3">
              <span class="word_7" :lines="1">目录</span>
            </div>
            <div class="block_5">
              <div class="color_2" />
              <span class="text_7" :lines="1">评论</span>
            </div>
          </div>
          <div class="block_6">
            <div class="colorDiv" />
            <span class="num_2" :lines="1">2</span>
          </div>
          <div class="empty_4" />
          <span class="txt_5" :lines="1">评价</span>
          <div class="group_6">
            <div class="userImageWrap">
              <img
                class="userImage"
                src="./images/img_32419_0_7.png"
              />
              <span class="txt_6" :lines="1">17***12</span>
            </div>
            <div class="container_6">
              <img
                class="icon_5"
                src="./images/img_32419_0_9.png"
              />
              <img
                class="icon_6"
                src="./images/img_32419_0_10.png"
              />
              <img
                class="icon_7"
                src="./images/img_32419_0_11.png"
              />
              <img
                class="icon_8"
                src="./images/img_32419_0_12.png"
              />
              <img
                class="icon_9"
                src="./images/img_32419_0_13.png"
              />
            </div>
          </div>
          <span class="article" :lines="3"
            >局与象号置实片走只关组白电层响京接委且需布新地习线合其极济南需活新音影安力改条统长力马平大处么区第经包江响最他。知候务构无长军正金知复度解现那状且太千间白相置八气前以位至品做就行要调学集存但应热化且展只许极满通里派南列别山府局。</span
          >
          <div class="container_7">
            <span class="text_8" :lines="1">2019-08-18</span>
            <span class="txt_7" :lines="1">10:37:29</span>
          </div>
          <div class="div_3" />
          <div class="block_8">
            <div class="userImgWrap">
              <img
                class="userImg"
                src="./images/img_32419_0_8.png"
              />
              <span class="word_8" :lines="1">17***12</span>
            </div>
            <div class="block_7">
              <img
                class="icon_10"
                src="./images/img_32419_0_14.png"
              />
              <img
                class="icon_11"
                src="./images/img_32419_0_15.png"
              />
              <img
                class="icon_12"
                src="./images/img_32419_0_16.png"
              />
              <img
                class="icon_13"
                src="./images/img_32419_0_17.png"
              />
              <img
                class="icon_14"
                src="./images/img_32419_0_18.png"
              />
            </div>
          </div>
          <span class="article_2" :lines="3"
            >局与象号置实片走只关组白电层响京接委且需布新地习线合其极济南需活新音影安力改条统长力马平大处么区第经包江响最他。知候务构无长军正金知复度解现那状且太千间白相置八气前以位至品做就行要调学集存但应热化且展只许极满通里派南列别山府局。</span
          >
          <div class="group_7">
            <span class="word_9" :lines="1">2019-08-18</span>
            <span class="text_9" :lines="1">10:37:29</span>
          </div>
        </div>
        <div class="list">
          <div class="row1">
            <div class="avatorWrap">
              <img
                class="avator"
                src="./images/img_32419_0_24.png"
              />
              <span class="text_10" :lines="1">赵茂华</span>
            </div>
            <div class="summaryWrap">
              <span class="javasePrev" :lines="2"
                >计算机专职讲师，具有丰富的项目开发经验。所讲授课程：</span
              >
              <span class="javase" :lines="1">JavaSE</span>
              <span class="javaseNext" :lines="1">语言基础；</span>
              <span class="txt_8" :lines="1">C</span>
            </div>
            <span class="txt_9" :lines="1">、</span>
            <div class="outer_4">
              <span class="jspampservlet" :lines="1">JSP&amp;Servlet</span>
              <span class="javaeePrev" :lines="1">、</span>
              <span class="javaee" :lines="1">JavaEE</span>
              <span class="htmlPrev" :lines="1">；</span>
              <span class="html" :lines="1">Html</span>
              <span class="htmlNext" :lines="1">、</span>
            </div>
            <div class="block_10">
              <span class="javascrip" :lines="1">JavaScrip</span>
              <span class="oraclePrev" :lines="1">；数据库原理，</span>
              <span class="oracle" :lines="1">Oracle</span>
              <span class="oracleNext" :lines="1">数据</span>
            </div>
            <div class="group_8">
              <span class="sqlserverPrev" :lines="1">库，</span>
              <span class="sqlserver" :lines="1">SQLServer</span>
              <span class="sqlserverNext" :lines="1"
                >数据库；授课风格：严谨</span
              >
            </div>
            <span class="summary_2" :lines="2"
              >灵活，案例生动，采用项目驱动的教学方式，在项目实践中激发学生的兴趣。</span
            >
            <div class="div_4" />
          </div>
          <div class="row2">
            <div class="userWrap">
              <img
                class="user"
                src="./images/img_32419_0_25.png"
              />
              <span class="text_11" :lines="1">赵茂华</span>
            </div>
            <div class="summaryWrap_2">
              <span class="javasePrev_2" :lines="2"
                >计算机专职讲师，具有丰富的项目开发经验。所讲授课程：</span
              >
              <span class="javase_2" :lines="1">JavaSE</span>
              <span class="javaseNext_2" :lines="1">语言基础；</span>
              <span class="txt_10" :lines="1">C</span>
            </div>
            <span class="text_12" :lines="1">、</span>
            <div class="block_11">
              <span class="jspampservlet_2" :lines="1">JSP&amp;Servlet</span>
              <span class="javaeePrev_2" :lines="1">、</span>
              <span class="javaee_2" :lines="1">JavaEE</span>
              <span class="htmlPrev_2" :lines="1">；</span>
              <span class="html_2" :lines="1">Html</span>
              <span class="htmlNext_2" :lines="1">、</span>
            </div>
            <div class="group_9">
              <span class="javascrip_2" :lines="1">JavaScrip</span>
              <span class="oraclePrev_2" :lines="1">；数据库原理，</span>
              <span class="oracle_2" :lines="1">Oracle</span>
              <span class="oracleNext_2" :lines="1">数据</span>
            </div>
            <div class="container_8">
              <span class="sqlserverPrev_2" :lines="1">库，</span>
              <span class="sqlserver_2" :lines="1">SQLServer</span>
              <span class="sqlserverNext_2" :lines="1"
                >数据库；授课风格：严谨</span
              >
            </div>
            <span class="summary_3" :lines="2"
              >灵活，案例生动，采用项目驱动的教学方式，在项目实践中激发学生的兴趣。</span
            >
          </div>
        </div>
      </div>
      <div class="submain">
        <div class="avatorWrap_2">
          <img
            class="avator_2"
            src="./images/img_32419_0_26.png"
          />
          <span class="txt_11" :lines="1">赵茂华</span>
        </div>
        <div class="summaryWrap_3">
          <span class="javasePrev_3" :lines="2"
            >计算机专职讲师，具有丰富的项目开发经验。所讲授课程：</span
          >
          <span class="javase_3" :lines="1">JavaSE</span>
          <span class="javaseNext_3" :lines="1">语言基础；</span>
          <span class="word_10" :lines="1">C</span>
        </div>
        <span class="txt_12" :lines="1">、</span>
        <div class="block_12">
          <span class="jspampservlet_3" :lines="1">JSP&amp;Servlet</span>
          <span class="javaeePrev_3" :lines="1">、</span>
          <span class="javaee_3" :lines="1">JavaEE</span>
          <span class="htmlPrev_3" :lines="1">；</span>
          <span class="html_3" :lines="1">Html</span>
          <span class="htmlNext_3" :lines="1">、</span>
        </div>
        <div class="group_10">
          <span class="javascrip_3" :lines="1">JavaScrip</span>
          <span class="oraclePrev_3" :lines="1">；数据库原理，</span>
          <span class="oracle_3" :lines="1">Oracle</span>
          <span class="oracleNext_3" :lines="1">数据</span>
        </div>
        <div class="block_13">
          <span class="sqlserverPrev_3" :lines="1">库，</span>
          <span class="sqlserver_3" :lines="1">SQLServer</span>
          <span class="sqlserverNext_3" :lines="1">数据库；授课风格：严谨</span>
        </div>
        <span class="summary_4" :lines="2"
          >灵活，案例生动，采用项目驱动的教学方式，在项目实践中激发学生的兴趣。</span
        >
      </div>
      <div class="empty_5" />
      <div class="row">
        <div class="userWrap_2">
          <img
            class="user_2"
            src="./images/img_32419_0_27.png"
          />
          <span class="txt_13" :lines="1">赵茂华</span>
        </div>
        <div class="summaryWrap_4">
          <span class="javasePrev_4" :lines="2"
            >计算机专职讲师，具有丰富的项目开发经验。所讲授课程：</span
          >
          <span class="javase_4" :lines="1">JavaSE</span>
          <span class="javaseNext_4" :lines="1">语言基础；</span>
          <span class="word_11" :lines="1">C</span>
        </div>
        <span class="text_13" :lines="1">、</span>
        <div class="group_11">
          <span class="jspampservlet_4" :lines="1">JSP&amp;Servlet</span>
          <span class="javaeePrev_4" :lines="1">、</span>
          <span class="javaee_4" :lines="1">JavaEE</span>
          <span class="htmlPrev_4" :lines="1">；</span>
          <span class="html_4" :lines="1">Html</span>
          <span class="htmlNext_4" :lines="1">、</span>
        </div>
        <div class="block_14">
          <span class="javascrip_4" :lines="1">JavaScrip</span>
          <span class="oraclePrev_4" :lines="1">；数据库原理，</span>
          <span class="oracle_4" :lines="1">Oracle</span>
          <span class="oracleNext_4" :lines="1">数据</span>
        </div>
        <div class="group_12">
          <span class="sqlserverPrev_4" :lines="1">库，</span>
          <span class="sqlserver_4" :lines="1">SQLServer</span>
          <span class="sqlserverNext_4" :lines="1">数据库；授课风格：严谨</span>
        </div>
        <span class="summary_5" :lines="2"
          >灵活，案例生动，采用项目驱动的教学方式，在项目实践中激发学生的兴趣。</span
        >
      </div>
      <div class="div_5" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {},
    };
  },
  methods: {},
};
</script>
<style src="./index.css" />
